import API, { ensurePrefixed } from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import { store } from 'store';

export const baseURI = 'tramites/tramites/';
const BASE_URI_QR = 'tramites/tramites-consulta/';

/**
 * GET Tramites
 * param {object} params
 * @returns {Promise<object>}
 */
export const getTramites = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return params.page ? { results: [] } : [];
  }
};

/**
 * GET Tramites
 * param {object} params
 * @returns {Promise<object>}
 */
export const getTramitesIndexados = async (params) => {
  try {
    const { data } = await API.get('tramites/tramites-indexados', { params });
    data.pasos_a_mandar = data.pasos_a_mandar || [];
    return {
      page: data.page,
      count: data.count,
      params,
      next: Boolean(data.next),
      prev: Boolean(data.prev),
      results: data.results,
    };
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Tramite
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getTramite = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Tramite
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTramite = async (values, { clave } = {}) => {
  try {
    const { user } = store.getState().auth;
    const accionInf = ensurePrefixed('CREAR_', 'TRAMITE');
    const response = await API.post(baseURI, {
      ...values,
      canal_de_pago: user.canal_de_pago,
    }, { accionInf, idPadron: values.tipo_padron_id, clave });
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tramite
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTramite = async (id, values) => {
  try {
    const esFinalizar = values.estados_globales === 4;
    const accionInf = esFinalizar ? 'FINALIZAR_TRAMITE' : 'EDITAR_TRAMITE';
    const response = await API.patch(`${baseURI}${id}`, values, { accionInf });
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tramite
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTramite = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST Tramite
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const cancelarTramite = async (values) => {
  try {
    const accionInf = ensurePrefixed('CANCELAR_', 'TRAMITE');
    const response = await API.post(`${baseURI}cancelar`, values, { accionInf });
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * POST Cancelar Tramite de Portal
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const cancelarTramiteDePortal = async (values) => {
  try {
    const response = await API.post(`${baseURI}/cancelar-con-orden-de-pago`, values);
    onSuccess(response, 'Cancelado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Tramite By folio
 * @param {number} folio
 * @returns {Promise<object>}
 */
export const getTramiteByFolio = async (folio, referencia_de_impresion) => {
  try {
    const response = await API.post(`${BASE_URI_QR}`, { folio, referencia_de_impresion });
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};
